"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * Return an arrow path for svg
 * @param tip arrow tip point
 * @param size arrow size
 * @param stroke arrow filled color
 * @param rotateAngle arrow rotation angle, default = 0
 */
function Arrow(props) {
    var path = "M\n                  " + props.tip.x + " " + props.tip.y + "\n                  l " + -props.size + " " + -props.size / 2 + "\n                  v " + props.size + "\n                  z\n                ";
    return (react_1.default.createElement("path", { d: path, fill: props.stroke, stroke: props.stroke, transform: "rotate(" + (props.rotateAngle || 0) + " " + props.tip.x + " " + props.tip.y + ")" }));
}
exports.default = Arrow;
